module.exports = __webpack_public_path__ + "media/images/flip_white-297ae08a2528674206210e05f2aa7c32461a2119c31fea35ee04ccb0f8fca1e3.svg";